import React, { useState } from 'react';
import { Box, Modal, Tooltip } from '@material-ui/core';

const modalBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '450px',
  outline: 'none',
};

const ShareProfileModal = ({ isOpen, onClose, shareLink }) => {
  const [tooltipText, setTooltipText] = useState('Copy to clipboard');

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setTooltipText('Copied!');
    setTimeout(() => setTooltipText('Copy to clipboard'), 2000);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
    >
      <Box style={{
        height: 'auto',
        backgroundColor: 'black',
        borderRadius: '15px',
        border: '1px solid rgba(255, 215, 0, 0.3)',
        padding: '25px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
      }} sx={modalBoxStyle}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <div style={{
            color: 'gold',
            fontSize: '24px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            textAlign: 'center',
            marginBottom: '10px'
          }}>
            Share Profile
          </div>

          <div style={{
            backgroundColor: 'rgba(255,255,255,0.05)',
            padding: '15px',
            borderRadius: '10px',
            position: 'relative'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center',
              backgroundColor: 'rgba(0,0,0,0.3)',
              borderRadius: '8px',
              border: '1px solid rgba(255, 215, 0, 0.2)',
              padding: '5px'
            }}>
              <input
                type="text"
                value={shareLink}
                readOnly
                onClick={(e) => {
                  e.target.select();
                  navigator.clipboard.writeText(e.target.value);
                }}
                style={{
                  flex: 1,
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: '#4CAF50',
                  fontSize: '14px',
                  height: '40px',
                  paddingLeft: '15px',
                  paddingRight: '45px'
                }}
              />
              <Tooltip title={tooltipText} placement="top">
                <button
                  onClick={handleCopy}
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'gold',
                    cursor: 'pointer',
                    padding: '8px',
                    fontSize: '16px',
                    marginLeft: '5px',
                    transition: 'transform 0.2s ease',
                    ':hover': {
                      transform: 'scale(1.1)'
                    }
                  }}
                >
                  <i className="fa-solid fa-copy"></i>
                </button>
              </Tooltip>
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '8px',
              color: 'black',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              backgroundColor: 'gold',
              textTransform: 'uppercase',
              border: 'none',
              transition: 'all 0.2s ease',
              ':hover': {
                backgroundColor: '#ffd700',
                transform: 'translateY(-2px)'
              }
            }}
          >
            Close
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ShareProfileModal;
